<template>
    <div class="pageBox">
        <div class="pageFrame">
            <left></left>
            <div class="frame">
                <div class="havaData" v-if="collectList.length>0">
                    <div class="collectBox">
                        <router-link
                            :to="{name:'ProductDetail',params:{pId:item.productId}}"
                            class="item_collect"
                            v-for="(item,index) in collectList"
                            :key="index">
                            <div class="imgBox">
                                <img :src="item.productImg" :alt="item.productName">
                            </div>
                            <div class="name">{{ item.productName }}</div>
                            <div class="like">
                                <img src="../../assets/images/like_on.png" alt="收藏">
                                <span>已收藏</span>
                            </div>
                            <div class="cancel" @click.prevent="cancel_confirm(item.id)">取消收藏</div>
                        </router-link>
                    </div>
                    <div>
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page.sync="pageIndex"
                            :page-sizes="[8, 12, 16, 20]"
                            :page-size="pageSize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="totalCount">
                        </el-pagination>
                    </div>
                </div>
                <div class="noData red" v-else>暂无收藏！</div>
            </div>
        </div>
    </div>
</template>

<script>
import left from './left'

export default {
    name: "collect",
    components: {
        left,
    },
    data() {
        return {
            collectList: [],
            totalCount: 8,
            pageSize: 8,
            pageIndex: 1,
            allow_cancel: true
        }
    },
    mounted() {
        document.title = '我的收藏' + this.$suffix
        this.$store.commit('modifyUserIndex', 2002)
        if (!this.$noLoginToLogin()) {
            this.getCollectList()
        }
    },
    methods: {
        handleSizeChange(val) {
            this.pageSize = val
            this.getCollectList()
        },
        handleCurrentChange(val) {
            this.pageIndex = val
            this.getCollectList()
        },

        /**
         * 获取收藏列表
         */
        getCollectList() {
            this.$post('/V1/Collect/GetCollectArray',
                {
                    "pageSize": this.pageSize,
                    "pageIndex": this.pageIndex,
                    "userId": Number(this.$store.state.user.userName),
                })
                .then((res) => {
                    // console.log('collect', res)
                    if (res.success) {
                        this.totalCount = res.response.totalCount
                        this.collectList = res.response.data
                    } else {
                        this.$message.error("网络错误，请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("网络错误，请重试");
                })
        },

        /**
         *确认是否取消收藏
         **/
        cancel_confirm(id) {
            this.$confirm('该产品将从收藏列表移除, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning '
            }).then(() => {
                this.cancelCollect(id)
            }).catch(() => {

            })
        },

        /**
         * 取消收藏
         */
        cancelCollect(id) {
            if (this.allow_cancel) {
                this.$post('/V1/Collect/DeleteCollect', {
                    ids: [id],
                })
                    .then((res) => {
                        // console.log('cancelCollect', res)
                        if (res.success) {
                            this.$message.success("已取消收藏！")
                            this.getCollectList()
                            setTimeout(() => {
                                this.allow_cancel = true
                            }, 1500)
                        } else {
                            this.$message.error("网络错误，请重试");
                            setTimeout(() => {
                                this.allow_cancel = true
                            }, 1500)
                        }
                    }).catch(() => {
                    this.$message.error("网络错误，请重试");
                    setTimeout(() => {
                        this.allow_cancel = true
                    }, 1500)
                })
            } else {
                setTimeout(() => {
                    this.allow_cancel = true
                }, 1500)
            }
        }
    }
}
</script>

<style scoped lang="less">

.pageBox {
    width: 100%;
    background-color: #f9f9f9;

    .pageFrame {
        width: 1210px;
        margin: 0 auto;
        display: flex;
        flex-direction: row;
        padding: 30px 0px;

        .frame {
            display: flex;
            flex-direction: column;
            padding: 40px;
            width: 880px;
            background-color: white;

            .collectBox {
                display: flex;
                flex-direction: row;
                width: 880px;
                flex-wrap: wrap;
                overflow: hidden;

                .item_collect:nth-child(4n) {
                    margin-right: 0px;
                }

                .item_collect {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    align-items: center;
                    border: 1px solid #ccc;
                    width: 200px;
                    height: 210px;
                    margin-right: 20px;
                    margin-bottom: 30px;

                    .imgBox {
                        width: 200px;
                        height: 100px;
                        overflow: hidden;

                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }

                    .name {
                        font-size: 16px;
                        color: #333;
                        margin-top: 20px;
                        max-width: 90%;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }

                    .like {
                        font-size: 14px;
                        color: #666;
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                    }

                    .cancel {
                        background-color: #e7e7e7;
                        height: 35px;
                        line-height: 35px;
                        text-align: center;
                        color: #666666;
                        font-size: 14px;
                        cursor: pointer;
                        width: 100%;
                    }

                    .cancel:hover {
                        background-color: #1f2d5c;
                        color: white;
                        transition: .5s;
                    }
                }
            }

            .red {
                color: #1f2d5c;
                margin: auto auto;
            }
        }
    }
}
</style>
